const resource = {
  "notifications": {
    "works": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["On 02/4/2025, from 7:45 to 8:45 (UTC+3), we’ll be performing technical maintenance. During this time, the service will be unavailable."])}
  },
  "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The site will be up and running shortly."])},
  "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["We carry out technical work."])}
}
export default resource